module.exports = __webpack_public_path__ + "img/proImg2.83b6db70.png";